import SVG from "svg.js";
import { Patient } from "@/store/modules/patient/types";
import { InfoWindow } from "./InfoWindow";
import { BodyConfig } from ".";
import { Store } from "vuex";
import _ from "lodash";

export class RightKidneyText extends InfoWindow {
  shiftX = 10;
  shiftY = 385;
  linesToBold = [];

  constructor(config: BodyConfig, container: SVG.Container, store: Store<any>) {
    super(config, container, store);
    this.shiftContent();
  }

  getExtraData(patient: Patient) {
    this.extraData = {
      cr: _.get(patient, "body.atoms.cr.legend", null),
      crCl: _.get(patient, "body.atoms.crCl.legend", null)
    };
  }
}
